// pay 플러그인 — 공용 플랫폼 호스팅 결제 (prd/112 FR-004·FR-008)
// 결제 페이지·결제사 연동은 플랫폼에 있다. 이 플러그인은 상품 id 로 결제 세션을 만들고 유저를 결제 페이지로 보낸다.
// 결제됐는지는 화면이 판정하지 않는다 — MVP API 가 플랫폼의 서명 알림을 받아 반영한다 (api/internal/entitlement)
import { z } from 'zod';

import { definePlugin } from '../../composition/plugin-runtime';
import { PLATFORM_URL } from '../../ports/platform';
import { payWidget } from './presentation/pay-widget';

export default definePlugin({
  name: 'pay',
  version: '0.1.0',
  // 결제 세션은 로그인 토큰이 있어야 만들 수 있다
  dependsOn: ['auth'],
  params: z.object({
    platformUrl: z.url(),
    /** 플랫폼 카탈로그의 상품 id. 금액·통화는 카탈로그가 정한다 — 여기 적지 않는다 */
    product: z.string().regex(/^[a-z0-9][a-z0-9_-]{0,39}$/),
  }),
  defaults: { params: { platformUrl: PLATFORM_URL, product: 'sample' } },
  setup(ctx, params) {
    ctx.messages('ko', {
      label: '결제',
      buy: '구매하기',
      needLogin: '로그인하면 구매할 수 있어요',
      'status.pending': '결제를 확인하고 있어요',
      'status.paid': '결제가 끝났어요',
      'status.cancelled': '결제를 취소했어요',
      'status.expired': '결제 시간이 지났어요. 다시 시도해 주세요',
      'status.failed': '결제하지 못했어요. 다시 시도해 주세요',
      'status.refunded': '환불된 결제예요',
      'error.login_required': '로그인이 풀렸어요. 다시 로그인해 주세요',
      'error.product_not_found': '아직 등록되지 않은 상품이에요',
      'error.payments_not_enabled': '지금은 결제할 수 없어요',
      'error.failed': '결제를 시작하지 못했어요. 잠시 뒤 다시 시도해 주세요',
    });
    ctx.messages('en', {
      label: 'Payment',
      buy: 'Buy',
      needLogin: 'Sign in to buy',
      'status.pending': 'Confirming your payment',
      'status.paid': 'Payment complete',
      'status.cancelled': 'Payment cancelled',
      'status.expired': 'Payment timed out. Please try again',
      'status.failed': 'Payment failed. Please try again',
      'status.refunded': 'This payment was refunded',
      'error.login_required': 'You were signed out. Please sign in again',
      'error.product_not_found': 'This product is not available yet',
      'error.payments_not_enabled': 'Payments are unavailable right now',
      'error.failed': 'Could not start the payment. Please try again shortly',
    });
    ctx.slot('home.main', payWidget(params), { priority: 20 });
  },
});
